/**
 * ===========================
 * MAIN
 * ===========================
 */
const HTML_ENTITIES: { [key: string]: string } = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&apos;': "'",
  '&nbsp;': ' ',
};

/**
 * Convert an HTML string into plain text.
 * Used to build structured data fields (eg: article description) out of
 * `post_description`, which comes from the API as rendered HTML.
 */
export const stripHtml = (html?: string): string => {
  if (!html) return '';

  return (
    html
      // drop script & style blocks together with their content
      .replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, ' ')
      // treat block level breaks as spaces so words don't get glued together
      .replace(/<(br|\/p|\/div|\/li|\/h[1-6])[^>]*>/gi, ' ')
      // remove every remaining tag
      .replace(/<[^>]+>/g, '')
      // decode the entities we are likely to receive
      .replace(
        /&(amp|lt|gt|quot|#39|apos|nbsp);/gi,
        (entity) => HTML_ENTITIES[entity.toLowerCase()] ?? entity
      )
      // collapse whitespace introduced by the replacements above
      .replace(/\s+/g, ' ')
      .trim()
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default stripHtml;
